<div class="grid" data-controller="generic/ui/ResponsiveGrid">
  <app-tile
    class="grid__unit s-4-4 m-6-12 ml-6-12 l-6-12 xl-4-12"
    *ngFor="let item of items$ | async"
    [item]="item"
  ></app-tile>
</div>
